const accountTypeModel = {
    '01': 'selfEmployed',
    '02': 'employed',
    '03': 'rentier',
    '04': 'pensioner',
    '05': 'withoutActivity',
};

const SELF_EMPLOYED_ID = '01';
const EMPLOYED_ID = '02';
const RENTIER_ID = '03';
const PENSIONER_ID = '04';
const WITHOUT_ACTIVITY_ID = '05';

export { accountTypeModel, SELF_EMPLOYED_ID, EMPLOYED_ID, RENTIER_ID, PENSIONER_ID, WITHOUT_ACTIVITY_ID };
